<template>
  <n-modal-background v-if="modals.length" ref="bg" :closeOnOutside="false" :closeOnEscape="false">
    <component
      v-for="config in modals"
      :key="config.id"
      :is="config.variant === 'confirm' ? 'NConfirm' : 'NAlert'"
      :title="config.title"
      :confirmButtonText="config.confirmButtonText"
      :confirmButtonIcon="config.confirmButtonIcon"
      :confirmLoading="config.id === confirmingModalId"
      @confirm="handleConfirm(config)"
      @cancel="handleCancel(config)"
      @close="handleClose(config)"
    >
      {{ config.message }}
    </component>
  </n-modal-background>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mapState, mapStores } from 'pinia'
import { ConfirmModalConfig, ConfirmModalStore, useConfirmModalStore } from '@/modules/global/stores/ConfirmModalStore'
import NAlert from '@/modules/global/components/core/NConfirmModal/NAlert.vue'
import NConfirm from '@/modules/global/components/core/NConfirmModal/NConfirm.vue'

@Component({
  components: {
    NAlert,
    NConfirm
  },
  computed: {
    ...mapState(useConfirmModalStore, ['modals']),
    ...mapStores(useConfirmModalStore)
  }
})
export default class NConfirmModalProvider extends Vue {
  private modals!: ConfirmModalConfig[]
  confirmModalStore!: ConfirmModalStore
  confirmingModalId: string | null = null

  handleCancel(config: ConfirmModalConfig) {
    if (this.confirmingModalId === config.id) {
      return
    }
    this.handleClose(config)
    if (config.onCancel) {
      config.onCancel()
    }
  }

  handleClose(config: ConfirmModalConfig) {
    this.confirmModalStore.remove(config.id)
    if (this.confirmingModalId === config.id) {
      this.confirmingModalId = null
    }
  }

  async handleConfirm(config: ConfirmModalConfig) {
    if (this.confirmingModalId) {
      return
    }

    this.confirmingModalId = config.id
    try {
      if (config.onConfirm) {
        await config.onConfirm()
      }
    } finally {
      this.handleClose(config)
    }
  }
}
</script>

<style scoped lang="scss"></style>
